export const BANNER_TIMEOUT = 7000;
export const SHARE_MESSENGER_MAX_RECIPIENTS = 20;
export const SHARE_MESSENGER_MESSAGE_MAX_LENGTH = 65000;
export const SHARE_MESSAGE_MAX_LENGTH = 420;
export const SHARE_FEEDBACK_URL_TRACKING = '?sc_o=social_share_feedback_created_share-click';
//# sourceMappingURL=constants.js.map